export default "__VITE_ASSET__bca58379__"